import { Box, Heading as GHeading, Paragraph } from "grommet";
import { useIsLarge } from "@cybertools/grommet/useIsLarge";
import CoinzillaInjection from "@components/coinzilla";

const Heading = ({ children, ...rest }) => {
  const large = useIsLarge();

  return (
    <Box
      direction={large ? "row" : "column-reverse"}
      justify="between"
      gap="medium"
      margin={{ top: "medium", bottom: "none" }}
      {...rest}
    >
      <Box>
        <GHeading margin="none">Airdrops</GHeading>
        <Paragraph margin="none" color="status-disabled">
          {children}
        </Paragraph>
      </Box>
      <CoinzillaInjection />
    </Box>
  );
};

export default Heading;
